import { storefrontApiClient as client } from './storefrontApiClient';
import { collectionByHandleWithLimit } from './queries';
import { productBasicFragment } from './fragments';
import { digestResponse, handleUserErrors } from './utils';

/**
 * Get a Collection by its handle
 * @param {string} collection handle
 * @param {number} retrive the first x products
 */
export const getCollectionByHandle = async(handle = '', first = 3) => {
	const variables = { handle, first };
	return client.request(collectionByHandleWithLimit, { variables })
	.then(digestResponse)
	.then(({data, errors}) => {
		const {
			collection,
		} = data || {};
		handleUserErrors(errors);
		return collection;
	});
};

/**
 * Get an array of products given an array of product handles
 * @param {string} product handle
 */
export const getProductsByHandle = async(handlesArr = []) => {
	const promiseArray = [];

	handlesArr.forEach(handle => {
		const productQuery = `
			{
				product: productByHandle(handle: "${ handle }") {
					...ProductBasicFragment
				}
			}

			${ productBasicFragment }
		`;
		const promise = client.request(productQuery)
		.then(digestResponse)
		.then(({data, errors}) => {
			const {
				product,
			} = data || {};
			handleUserErrors(errors);
			return product;
		});
		promiseArray.push(promise);
	});

	//	Response is an array of Product Objects [<Product>]
	const responses = await Promise.all(promiseArray);
	return responses.filter(Boolean);
};

/**
 * Get an array of products given an array of product ids
 * @param {string} product id
 */
export const getProductsById = async(idsArr = []) => {
	const promiseArray = [];

	idsArr.forEach(id => {
		const productQuery = `
			{
				product(id: "${id}") {
					...ProductBasicFragment
					variants(first: 250) {
						edges {
							node {
								id
								sku
								title
							}
						}
					}
				}
			}

			${ productBasicFragment }
		`;

		const promise = client.request(productQuery)
		.then(digestResponse)
		.then(({data, errors}) => {
			const {
				product,
			} = data || {};
			handleUserErrors(errors);
			return product;
		});
		promiseArray.push(promise);
	});

	//	Response is an array of Product Objects [<Product>]
	const responses = await Promise.all(promiseArray);
	return responses.filter(Boolean);
};
